import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { ObjectFieldDTO } from '@types'

type ValueTypeOfSelectedValueOptions = {
  objectField: ObjectFieldDTO | undefined | Record<string, any>
  valueTypeInputName: string
}

export const useValueTypeOfSelectedValue = ({
  objectField,
  valueTypeInputName,
}: ValueTypeOfSelectedValueOptions) => {
  const { setValue } = useFormContext()
  const [selectedValueType, setSelectedValueType] = useState('')

  useEffect(() => {
    if (objectField?.valueType) {
      const valueType = objectField.valueType as string
      setSelectedValueType(valueType)
      setValue(valueTypeInputName, valueType, { shouldDirty: true })
    }
  }, [objectField, valueTypeInputName, setValue])

  return { selectedValueType, setSelectedValueType }
}
